<template>
  <div>
    <mdb-modal :show="modal" @close="close">
      <mdb-modal-header>
        <mdb-modal-title>Filter</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <slot name="content"/>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn
          color="grey lighten-1"
          @click.native="close"
        >
          Abbrechen
        </mdb-btn>
        <mdb-btn color="primary"
          @click="filter"
        >
          Anwenden
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn
  } from 'mdbvue'

  export default {
    name: 'SettingModal',

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        modal: false
      };
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
    },

    methods: {
      close () {
        this.$emit('close')
      },

      filter () {
        this.$emit('filter')
      }
    }
  };
</script>
